<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard>
        <CCardHeader>
          <strong>Entry Details</strong> (uid : {{ this.$route.params.id }})
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CInput
              label="Phone Number"
              horizontal
              autocomplete="name"
              type="phone"
              plaintext
              v-model="user.phoneNumber"
            />
            <CInput label="UID" horizontal plaintext v-model="user.uID" />
            <CInput
              label="countryNameCode"
              horizontal
              plaintext
              v-model="user.countryNameCode"
            />
            
            <CInput label="amountGave" plaintext horizontal v-model="user.amountSumGave" />
            <CInput label="amountGot" plaintext horizontal v-model="user.amountSumGot" />
           
          </CForm>
        </CCardBody>
        <CCardFooter>
          <!-- <CButton type="submit" size="sm" color="primary" @click="submit"
            ><CIcon name="cil-check-circle" /> Save</CButton
          > -->
          <CButton type="reset" size="sm" color="danger" @click="goBack"
            ><CIcon name="cil-ban" /> Back</CButton
          >
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import firebase from "firebase";
//import usersData from "./UsersData";
export default {
  name: "Business",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.usersOpened = from.fullPath.includes("users");
    });
  },
  data() {
    return {
      usersOpened: null,
      user: {
        uID: "",
        phoneNumber: "13904482308",
        countryNameCode: "US",
        amountSumGave: 0,
        amountSumGot: 0,
      
      },
    };
  },
  computed: {
    fields() {
      return [
        { key: "key", label: this.username, _style: "width:150px" },
        { key: "value", label: "", _style: "width:150px;" },
      ];
    },
    userData() {
      const id = this.$route.params.id;

      const userDetails = user ? Object.entries(user) : [["id", "Not found"]];
      return userDetails.map(([key, value]) => {
        return { key, value };
      });
    },
    visibleData() {
      return this.userData.filter((param) => param.key !== "username");
    },
    username() {
      return this.userData.filter((param) => param.key === "username")[0].value;
    },
  },
  created() {
    const id = this.$route.params.id;
    var db = firebase.firestore();
    db.collection("users")
      .doc(id)
      .get()
      .then((doc) => {
        if (doc.exists) {
          console.log("Document data:", doc.data());
          this.user = doc.data();
          this.user.uID = doc.id;
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch((error) => {
        console.log("Error getting document:", error);
      });
  },
  methods: {
    goBack() {
      this.usersOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: "/users" });
    },
    submit() {
      var db = firebase.firestore();
      db.collection("users")
        .doc(this.user.uid)
        .update({
          phoneNumber: this.user.phoneNumber,
          countryNameCode: this.user.countryNameCode,
          role: this.user.role,
          amountGave: this.user.amountGave,
          amountGot: this.user.amountGot
        })
        .then(() => {
          console.log("Document successfully written!");
          this.usersOpened
            ? this.$router.go(-1)
            : this.$router.push({ path: "/users" });
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
    },
  },
};
</script>
